import { LabeledValue } from "@risalabs_frontend_org/oasis-ui-kit";
import { AuthorizationCardInfoProps } from "../../../../data-model/authLetterSuccessModel";
import AuthorizationHeader from "./authorizationHeader";
import ServiceCardInfoCard from "./serviceCardInfoCard";

/**
 * Card summarising one authorization: a header, a grid of detail fields,
 * and a list of service-code cards.
 *
 * @param props.header - Header content passed to `AuthorizationHeader`.
 * @param props.details - Label/value pairs for the details grid.
 * @param props.serviceCodes - Service codes passed to `ServiceCardInfoCard`.
 */
const AuthorizationCardInfo = ({
  header,
  details,
  serviceCodes,
}: AuthorizationCardInfoProps) => {
  const BASE_CLASS_NAME = "authorization-card-info-container";
  return (
    <div
      className={`${BASE_CLASS_NAME} flex flex-col gap-3 rounded-md border border-primaryGray-15 p-4`}
    >
      <div className={`${BASE_CLASS_NAME}__header`}>
        <AuthorizationHeader {...header} />
      </div>
      <div
        className={`${BASE_CLASS_NAME}__details grid grid-cols-2 gap-2 border-b border-primaryGray-15 pb-2`}
      >
        {details.map((detail, index) => (
          <LabeledValue
            key={`${detail.label}-${index}`}
            label={detail.label}
            value={detail.value}
            labelClassName="text-x-tiny font-bold text-primaryGray-6"
            valueClassName="text-tiny font-normal text-primaryGray-1"
          />
        ))}
      </div>
      <div className={`${BASE_CLASS_NAME}__service-code flex flex-col gap-2`}>
        <div className={`${BASE_CLASS_NAME}__service-code-title`}>
          <div className="text-x-tiny font-bold text-primaryGray-6">
            Service Codes
          </div>
        </div>
        {serviceCodes.map((serviceCode, index) => (
          <ServiceCardInfoCard
            key={`${serviceCode.code}-${index}`}
            code={serviceCode.code}
          />
        ))}
      </div>
    </div>
  );
};

export default AuthorizationCardInfo;
